import React, { useEffect, useRef, useState } from 'react';
import './ScreenSaver.css';

const ScreenSaver = ({ isActive, onWakeUp }) => {
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const handleVideoLoaded = () => {
    console.log('Video loaded and ready');
    setVideoLoaded(true);
  };

  useEffect(() => {
    console.log('ScreenSaver isActive:', isActive, 'videoLoaded:', videoLoaded);
    if (isActive && videoLoaded && videoRef.current) {
      console.log('Playing video...');
      videoRef.current.play().catch(err => {
        console.log('Video autoplay failed:', err);
      });
    }
  }, [isActive, videoLoaded]);

  useEffect(() => {
    if (!isActive) return;

    // Wake up on any mouse movement
    const handleMouseMove = () => {
      onWakeUp();
    };

    // Wake up on any click
    const handleClick = () => {
      onWakeUp();
    };

    // Wake up on any key press
    const handleKeyDown = () => {
      onWakeUp();
    };

    // Add event listeners
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('click', handleClick);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isActive, onWakeUp]);

  if (!isActive) return null;

  return (
    <div className="screen-saver">
      <video
        ref={videoRef}
        className="screen-saver-video"
        src="/docs/screen-saver-pipes.mp4"
        loop
        muted
        playsInline
        onLoadedData={handleVideoLoaded}
      />
    </div>
  );
};

export default ScreenSaver;
